export const BACKSPACE = 8
export const TAB = 9
export const ENTER = 13
export const SHIFT = 16
export const ALT = 18
export const ESCAPE = 27
export const ARROW = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39
}
export const DELETE = 46
export const ZERO = 48
export const ONE = ZERO + 1
export const TWO = ZERO + 2
export const THREE = ZERO + 3
export const FOUR = ZERO + 4
export const FIVE = ZERO + 5
export const SIX = ZERO + 6
export const SEVEN = ZERO + 7
export const EIGHT = ZERO + 8
export const NINE = ZERO + 9
export const A = 65
export const B = A + 1
export const C = A + 2
export const D = A + 3
export const E = A + 4
export const F = A + 5
export const G = A + 6
export const H = A + 7
export const I = A + 8
export const J = A + 9
export const K = A + 10
export const L = A + 11
export const M = A + 12
export const N = A + 13
export const O = A + 14
export const P = A + 15
export const Q = A + 16
export const R = A + 17
export const S = A + 18
export const T = A + 19
export const U = A + 20
export const V = A + 21
export const W = A + 22
export const X = A + 23
export const Y = A + 24
export const Z = A + 25
export const COLON = 186
export const COMMA = 188
export const DOT = 190
export const SLASH = 191
